import React, { useEffect } from "react";
import { Input } from "reactstrap";
import { useRecoilState } from "recoil";
import { filterSelector } from "../../actions/LayoutMode.actions";

import { useAsyncDebounce } from "react-table";

export const Filter = ({ column }: any) => {
  return (
    <div style={{ marginTop: 5 }}>
      {column.canFilter && column.render("Filter")}
    </div>
  );
};

interface DefaultColumnFilterProps {
  column: any;
}
export const DefaultColumnFilter = ({
  column: {
    filterValue,
    setFilter,
    preFilteredRows: { length },
    id,
  },
}: DefaultColumnFilterProps) => {
  const [filterState, setFilterState] = useRecoilState(filterSelector);

  useEffect(() => {
    if (id === "country") {
      filterValue = filterState.countrySearch;
      setFilter(filterState.countrySearch || undefined);
    }

    if (id === "district") {
      filterValue = filterState.districtSearch;
      setFilter(filterState.districtSearch || undefined);
    }

    if (id === "neighbourhood") {
      filterValue = filterState.neighbourhoodSearch;
      setFilter(filterState.neighbourhoodSearch || undefined);
    }

    if (id === "address_description") {
      filterValue = filterState.addressDescriptionSearch;
      setFilter(filterState.addressDescriptionSearch || undefined);
    }

    if (id === "phone_number") {
      filterValue = filterState.phoneNumberSearch;
      setFilter(filterState.phoneNumberSearch || undefined);
    }
  }, []);

  const onChangeBouncy = useAsyncDebounce((value: any) => {
    setFilterState((prevState) => ({
      ...prevState,
      countrySearch: id === "country" ? value : "",
      districtSearch: id === "district" ? value : "",
      neighbourhoodSearch: id === "neighbourhood" ? value : "",
      addressDescriptionSearch: id === "address_description" ? value : "",
      phoneNumberSearch: id === "phone_number" ? value : "",
    }));
  }, 200);

  return (
    <Input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
        onChangeBouncy(e.target.value);
      }}
      // onChange={(e) => {
      //   setFilter(e.target.value || undefined);

      //   setFilterState((prevState) => ({
      //     ...prevState,
      //     countrySearch: id === "country" ? e.target.value : "",
      //     districtSearch: id === "district" ? e.target.value : "",
      //     neighbourhoodSearch: id === "neighbourhood" ? e.target.value : "",
      //     addressDescriptionSearch:
      //       id === "address_description" ? e.target.value : "",
      //     phoneNumberSearch: id === "phone_number" ? e.target.value : "",
      //   }));
      // }}
      autoComplete="off"
      placeholder={`arama (${length}) ...`}
    />
  );
};

interface SelectColumnFilterProps {
  column: any;
}

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}: SelectColumnFilterProps) => {
  const options: any = React.useMemo(() => {
    const options: any = new Set();
    preFilteredRows.forEach((row: any) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      id="custom-select"
      className="form-select"
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value="">All</option>
      {options.map((option: any) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};
